import {FC} from 'react'
import { Category } from '../../core/_models'

type Props = {
  category: Category
}

const CategoryTypeCell: FC<Props> = ({category}) => {
  return (
    <>
      {
        <div className='d-flex align-items-center'>
        {/* begin:: Avatar */}
        <div className='d-flex flex-column'>
            {category.type}
        </div>
      </div>
      }
    </>
  )
}

export {CategoryTypeCell}
